import { NotifyError, NotifySuccess } from "../Notify/notify";

const BASE = () => process.env.REACT_APP_API_BASE_URL + '/torks';
const authHeader = (jwtToken) => ({ Authorization: `Bearer ${jwtToken}` });
const jsonHeader = (jwtToken) => ({ "Content-Type": "application/json", ...authHeader(jwtToken) });

export const GetTorks = (jwtToken, callback) => {
    fetch(BASE(), { headers: authHeader(jwtToken) })
        .then(res => res.json())
        .then(res => callback(res))
        .catch(() => NotifyError("Kunde inte hämta torkar."));
}

export const GetTork = (id, jwtToken, callback) => {
    fetch(BASE() + '/' + id, { headers: authHeader(jwtToken) })
        .then(res => res.json())
        .then(res => callback(res))
        .catch(() => NotifyError("Kunde inte hämta tork."));
}

export const CreateTork = (tork, jwtToken, callback) => {
    fetch(BASE(), {
        method: "POST",
        body: JSON.stringify(tork),
        headers: jsonHeader(jwtToken)
    })
        .then(res => res.json())
        .then(res => {
            NotifySuccess("Tork skapad!");
            callback(res);
        })
        .catch(() => NotifyError("Kunde inte skapa tork."));
}

export const UpdateTork = (tork, jwtToken, callback) => {
    fetch(BASE(), {
        method: "PUT",
        body: JSON.stringify(tork),
        headers: jsonHeader(jwtToken)
    })
        .then(res => res.json())
        .then(res => {
            NotifySuccess("Tork uppdaterad!");
            callback(res);
        })
        .catch(() => NotifyError("Kunde inte uppdatera tork."));
}

export const DeleteTork = (id, jwtToken, callback) => {
    fetch(BASE() + '/' + id, {
        method: "DELETE",
        headers: authHeader(jwtToken)
    })
        .then(res => res.json())
        .then(() => {
            NotifySuccess("Tork borttagen!");
            callback();
        })
        .catch(() => NotifyError("Kunde inte ta bort tork."));
}

export const AddTorkNote = (torkId, note, jwtToken, callback) => {
    fetch(BASE() + '/' + torkId + '/notes', {
        method: "POST",
        body: JSON.stringify(note),
        headers: jsonHeader(jwtToken)
    })
        .then(res => res.json())
        .then(res => {
            NotifySuccess("Notering tillagd!");
            callback(res);
        })
        .catch(() => NotifyError("Kunde inte lägga till notering."));
}

export const UpdateTorkNote = (torkId, noteId, note, jwtToken, callback) => {
    fetch(BASE() + '/' + torkId + '/notes/' + noteId, {
        method: "PUT",
        body: JSON.stringify(note),
        headers: jsonHeader(jwtToken)
    })
        .then(res => res.json())
        .then(res => {
            NotifySuccess("Notering uppdaterad!");
            callback(res);
        })
        .catch(() => NotifyError("Kunde inte uppdatera notering."));
}

export const DeleteTorkNote = (torkId, noteId, jwtToken, callback) => {
    fetch(BASE() + '/' + torkId + '/notes/' + noteId, {
        method: "DELETE",
        headers: authHeader(jwtToken)
    })
        .then(res => res.json())
        .then(res => {
            NotifySuccess("Notering borttagen!");
            callback(res);
        })
        .catch(() => NotifyError("Kunde inte ta bort notering."));
}
export const UpdateTorkNoteStatus = (torkId, noteId, status, jwtToken, callback) => {
    fetch(BASE() + '/' + torkId + '/notes/' + noteId + '/status', {
        method: "POST",
        body: JSON.stringify({ status }),
        headers: jsonHeader(jwtToken)
    })
        .then(res => res.json())
        .then(res => callback(res))
        .catch(() => NotifyError("Kunde inte ändra noteringsstatus."));
}
